// Medición: GA4 + Meta Pixel. Mapa de eventos en Marketing/WEBS.md (repo del libro).
// El pixel queda apagado hasta que exista el ID (Events Manager del Business Manager 955556056855366):
// REACT_APP_META_PIXEL_ID en Vercel (Settings > Environment Variables).
// Para ver los eventos en vivo: agregar ?debug=1 a la URL (salen en la consola y en GA4 > Admin > DebugView).
export const GA_ID = 'G-YVX2DT0W45';
export const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || '';
const SUBSTACK = 'https://nachoparietti.substack.com';

const params = () => new URLSearchParams(window.location.search);
const DEBUG = typeof window !== 'undefined' && params().get('debug') === '1';
let pageLang = 'en';

let started = false;
export function startTracking(lang) {
  pageLang = lang;
  if (started || typeof window === 'undefined') return;
  started = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  // page_lang viaja en todos los eventos; GA4 toma solo los utm_* de la URL
  window.gtag('config', GA_ID, { page_lang: lang, ...(DEBUG ? { debug_mode: true } : {}) });

  if (META_PIXEL_ID) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
  }
  watchScroll();
}

// evento genérico: siempre lleva el idioma de la página y la fuente del anuncio
export function track(name, p = {}) {
  const payload = { page_lang: pageLang, traffic_source: params().get('utm_source') || 'direct', ...p };
  if (window.gtag) window.gtag('event', name, payload);
  if (DEBUG) console.info('[track]', name, payload);
}

// edition: en | es · format: kindle | paperback | any · store: amazon-us, barnes-noble... · location: dónde estaba el botón
export function trackAmazon(edition, format, store = 'amazon-us', location = '') {
  const p = { edition, format, store, location };
  track('click_amazon', p);
  if (window.fbq) window.fbq('trackCustom', 'ClickAmazon', p);
}

export function trackView(name) {
  track('view_' + name);
  if (window.fbq) window.fbq('track', 'ViewContent', { content_name: name });
}

// profundidad de scroll: 25 / 50 / 75 / 100 % (GA4 solo mide 90 % por su cuenta)
function watchScroll() {
  const marks = [25, 50, 75, 100], sent = new Set();
  const on = () => {
    const h = document.documentElement.scrollHeight - window.innerHeight;
    if (h <= 0) return;
    const pct = (window.scrollY / h) * 100;
    for (const m of marks) if (pct >= m - 1 && !sent.has(m)) { sent.add(m); track('scroll_depth', { percent: m }); }
  };
  window.addEventListener('scroll', on, { passive: true });
}

// una vez por sección y por visita: qué partes de la página llega a ver la gente
export function watchSections(root = document) {
  const seen = new Set();
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) {
      const name = e.target.dataset.section;
      if (e.isIntersecting && !seen.has(name)) { seen.add(name); track('section_view', { section: name }); }
    }
  }, { threshold: 0.35 });
  root.querySelectorAll('[data-section]').forEach((el) => io.observe(el));
  return () => io.disconnect();
}

// Alta a la lista de Substack sin salir de la página. Substack no responde CORS,
// así que el envío es "a ciegas" (no-cors): Substack manda el mail de confirmación.
export async function subscribe(email, origin) {
  const body = new URLSearchParams({
    email, first_url: window.location.href, first_referrer: document.referrer,
    current_url: window.location.href, current_referrer: document.referrer, source: 'embed',
  });
  await fetch(`${SUBSTACK}/api/v1/free?nojs=true`, { method: 'POST', mode: 'no-cors', body });
  track('generate_lead', { origin });
  if (window.fbq) window.fbq('track', 'Lead', { content_name: origin });
}
export const SUBSTACK_URL = SUBSTACK;
